module.exports = __webpack_public_path__ + "static/media/ordermodeblr.910b93e3.png";